import request from '@/utils/request'


// 查询规格选项树（支持无限层级）列表
export function listSpecOption(query) {
  return request({
    url: '/user/spec-option/list',
    method: 'get',
    params: query
  })
}

/** zb_spec_option 关联 zb_spec 且规格 is_calculation=1 的选项列表（无查询参数） */
export function listSpecOptionJoinSpecCalculation() {
  return request({
    url: '/user/spec-option/list-join-spec-calculation',
    method: 'get'
  })
}

// 查询规格选项树（支持无限层级）分页
export function pageSpecOption(query) {
  return request({
    url: '/user/spec-option/page',
    method: 'get',
    params: query
  })
}

// 查询规格选项树（支持无限层级）详细
export function getSpecOption(data) {
  return request({
    url: '/user/spec-option/detail',
    method: 'get',
    params: data
  })
}

// 新增规格选项树（支持无限层级）
export function addSpecOption(data) {
  return request({
    url: '/user/spec-option/add',
    method: 'post',
    data: data
  })
}

// 修改规格选项树（支持无限层级）
export function updateSpecOption(data) {
  return request({
    url: '/user/spec-option/edit',
    method: 'post',
    data: data
  })
}

// 仅更新排序（不走 edit）
export function updateSpecOptionSort(data) {
  return request({
    url: '/user/spec-option/update-sort',
    method: 'post',
    data: data
  })
}

// 仅更新状态（不走 edit）
export function updateSpecOptionStatus(data) {
  return request({
    url: '/user/spec-option/update-status',
    method: 'post',
    data: data
  })
}

// 删除规格选项树（支持无限层级）
export function delSpecOption(data) {
  return request({
    url: '/user/spec-option/delete',
    method: 'post',
    data: data
  })
}
